import React from 'react';
import { LoginHeader, Input, Button, Link, Toast } from '@app/components';
import { useLocation } from '@app/utils';
import { useForm } from 'react-hook-form';
import {
  Container,
  InnerContainer,
  Text,
  Heading,
  ErrorMessage,
  ResendText,
  SavingIndicator,
  ResetContainer,
  ResetText,
  AccountText,
  MobileText,
} from '@app/modules/forgot-password/forgot-password-components';
import { ResetPassword } from '@app/auth/firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import DefaultErroPage from '@app/components/error-pages/default-error-page';

export default function ForgotPassword() {
  const [showResendPage, updateShowResend] = React.useState(false);
  const [showErrorPage, SetShowErrorPage] = React.useState(false);
  const { register, errors, handleSubmit } = useForm();
  const [email, updateEmail] = React.useState('');
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const [emailError, updateEmailError] = React.useState('');
  const [saving, updateSaving] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);

  const { navigate } = useLocation();
  function onSubmit() {
    if (!email) {
      updateEmailError('Please enter email');
    }
    if (!emailPattern.test(email)) {
      updateEmailError('Please enter valid email');
    }
    if (email && emailPattern.test(email)) {
      updateEmailError('');
      updateSaving(true);
      ResetPassword(email)
        .then((result: any) => {
          if (result.success) {
            updateShowResend(true);
            updateSaving(false);
            setTimeout(function() {
              updateShowResend(false);
              navigate('/sign-in');
            }, 20000);
          } else if (
            result.error &&
            result.error.code === 'auth/user-not-found'
          ) {
            updateEmailError('User Not Found');
            updateSaving(false);
          }
        })
        .catch((error: any) => {
          updateSaving(false);
          SetShowErrorPage(true);
        });
    }
  }
  function resendLink() {
    setShowToast(true);
    ResetPassword(email);
    setTimeout(() => {
      setShowToast(true);
    }, 1000);
  }
  function onChange(data: any) {
    if (data.target.name === 'email') {
      updateEmail(data.target.value);
      if (data.target.value) {
        updateEmailError('');
      }
    }
  }
  return (
    <>
      {showErrorPage ? (
        <DefaultErroPage />
      ) : (
        <>
          <LoginHeader />
          <Container>
            <Toast
              message="Reset Password has been sent to your Email"
              showToast={showToast}
              onClose={() => setShowToast(false)}
            />
            {!showResendPage ? (
              <InnerContainer disabled={saving}>
                <Heading>Forgot your password?</Heading>
                <Text>
                  Don't worry. Resetting your password is easy, just tell us{' '}
                  <br />
                  the email address you registered with Transfer Stamp.
                </Text>
                <MobileText>
                  Don't worry. Resetting your password is easy, just tell us the
                  email address you registered with Transfer Stamp.
                </MobileText>
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  onChange={onChange}
                  autoComplete="off">
                  <Input
                    register={register({ required: true })}
                    label="Email Address"
                    name="email"
                    placeholder="you@example.com"
                  />
                  <ErrorMessage>
                    {errors.email || emailError
                      ? emailError || 'Please enter Email'
                      : ''}
                  </ErrorMessage>
                  <Button
                    type="submit"
                    variant="primary"
                    width="100%"
                    size="large">
                    Send
                    {saving ? (
                      <SavingIndicator>
                        <FontAwesomeIcon
                          color="#fff"
                          icon={faCircleNotch}
                          size="lg"
                          spin
                        />
                      </SavingIndicator>
                    ) : null}
                  </Button>
                </form>
                <AccountText>
                  Don't have an account ?{' '}
                  <Link href="/sign-up" variant="secondary">
                    Sign Up
                  </Link>
                </AccountText>
              </InnerContainer>
            ) : (
              <ResetContainer disabled={saving}>
                <Heading>Reset your password</Heading>
                <ResetText>
                  We sent a reset password email to {email}, Please click the
                  reset password link to set your new password.
                </ResetText>
                <Text>
                  Didn't receive the email yet?
                  <br />{' '}
                  <ResendText onClick={resendLink}>Resend Email</ResendText>
                </Text>
              </ResetContainer>
            )}
          </Container>
        </>
      )}
    </>
  );
}
